import NotFoundCmp from "../Components/NotFound/NotFound";
import useTitle from "../hooks/useTitle";
const NotFound = () => {
  useTitle("Page Not Found");
  return <NotFoundCmp />;
};

export default NotFound;
